import type ItemId from 'owa-service/lib/contract/ItemId';

const mapStaffMemberIds = (staffMemberIds: string[] | undefined): ItemId[] | undefined => {
    if (!staffMemberIds) {
        return;
    }
    return staffMemberIds.map(staffMemberId => {
        return { Id: staffMemberId } as ItemId;
    });
};

export default mapStaffMemberIds;
